
import { defineComponent } from "vue";
import { Content } from "@/generic";
import OrderEdit from "@/client/components/order/Edit.vue";
import UserName from "@/shared/components/CurrentUserName.vue";

export default defineComponent({
  components: {
    Content,
    OrderEdit,
    UserName,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
});
